module.exports = "<div class=\"text-center\">\r\n    <h6 class=\"m-0 pb-1\">{{ title }}</h6>\r\n    <div mat-dialog-content>\r\n        <mat-spinner [style.margin]=\"'auto'\"></mat-spinner>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Programing/carbooking/src/app/shared/services/app-loader/app-loader.component.html
// module id = ../../../../../src/app/shared/services/app-loader/app-loader.component.html
// module chunks = main